import { AppBar, Box, Grid, Link, Stack } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import NetumLogo from '../../assets/images/Netum_logo_rgb_white.svg'
import { useStore } from '../../Provider'
import '../styles/footer.scss'
import { SlackIcon } from '../styles/Icons'

const OPFooter = (): JSX.Element => {
  const rootStore = useStore()
  const { isOpen } = rootStore.sidebarStore
  const { t } = useTranslation()
  return (
    <AppBar position='fixed' className='footer'>
      <Stack className={'centerLinks' + (!isOpen ? ' collapsed' : '')}>
        <Grid item xs={12} className='displayflex'>
          <Grid item className='slackicon'>
            <SlackIcon />
          </Grid>
          <Link
            className='opFont'
            href='https://netum-dev.slack.com/archives/CMHPSNRDX'
            target='_blank'
            rel='noopener noreferrer'
            underline='none'
          >
            #osaamispankki
          </Link>
        </Grid>
        <Grid item xs={12}>
          <Link
            className='tsFont'
            underline='none'
            target='_blank'
            href='https://netum.sharepoint.com/henkilosto/SitePages/Ty%C3%B6ntekij%C3%A4n-tietosuoja.aspx'
            rel='noopener noreferrer'
          >
            {t('HomePage.PrivacyPolicy')}
          </Link>
        </Grid>
      </Stack>
      <Box className='footerPic'>
        <img src={NetumLogo} alt='Netum' style={{ height: '100%', width: 'auto' }} />
      </Box>
    </AppBar>
  )
}
export default observer(OPFooter)
